import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const UniversityLanding = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("monthly");

  const handleCardClick = () => {
    const currentParams = location.search;
    navigate(`/university-card_detail-corporativo-mobile${currentParams}`);
  };

  const handleSignOut = () => {
    const currentParams = location.search;
    navigate(`/university-login-corporativo-mobile${currentParams}`);
  };

  return (
    <div className="university-landing">
      <div className="university-landing-container">
        {/* Header */}
        <div className="university-header">
          <div className="university-header-left">
            <div className="university-avatar">
              <img src="/img/avatar-placeholder.png" alt="User" onError={(e) => {
                e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="%23E5E7EB"/><circle cx="20" cy="16" r="8" fill="%239CA3AF"/><path d="M4 38c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="%239CA3AF"/></svg>';
              }} />
            </div>
            <span className="university-welcome-text">Welcome! Avila Leonel Gaston</span>
          </div>
          <div className="university-header-right">
            <div className="university-notification-icon" style={{ backgroundColor: colors.primario }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Card Section */}
        <div className="university-card-section">
          {colors.url_card ? (
            <div className="university-card-image-wrapper" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
              <img src={colors.url_card} alt="Credit Card" className="university-card-image" />
            </div>
          ) : (
            <div className="university-default-card" onClick={handleCardClick} style={{ backgroundColor: colors.primario, cursor: 'pointer' }}>
              <div className="default-card-top">
                <div className="default-card-dots">**** **** **** 2481</div>
                <div className="default-card-brand">VISA</div>
              </div>
              <div className="default-card-bottom">
                <button className="default-card-details-btn">
                  More details
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18l6-6-6-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <div className="default-card-expiry">
                  <span className="default-card-expiry-label">05/2028</span>
                  <span className="default-card-expiry-sub">Pay date</span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Freeze Card + Balance Row */}
        <div className="university-freeze-row">
          <div className="university-freeze-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" stroke="#374151" strokeWidth="2"/>
              <path d="M12 3v18M3 12h18M5.63 5.63l12.74 12.74M18.37 5.63L5.63 18.37" stroke="#374151" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span>Freeze Card</span>
          </div>
          <div className="university-balance-badge" style={{ backgroundColor: colors.primario }}>
            <span className="university-balance-amount">$7,697.50</span>
            <span className="university-balance-currency">USD</span>
          </div>
        </div>

        {/* Campus Deals Section */}
        <div className="university-deals-section">
          <div className="university-deals-header">
            <h2 className="university-deals-title">Campus Deals</h2>
            <button className="university-deals-viewall" style={{ color: colors.primario }}>
              View All Deals
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          <div className="university-deal-card" style={{ backgroundImage: 'url(/img/promocion1.jpg)' }}>
            <div className="university-deal-overlay">
              <p className="university-deal-text">20% off at Campus Cafeteria</p>
              <button className="university-deal-redeem" style={{ backgroundColor: colors.primario }}>
                Redeem Offer
              </button>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="university-quick-actions">
          <div className="university-action-box">
            <div className="university-action-circle" style={{ backgroundColor: colors.primario }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="6" width="18" height="14" rx="2" stroke="white" strokeWidth="1.5"/>
                <path d="M3 10h18" stroke="white" strokeWidth="1.5"/>
                <path d="M7 15h4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <span className="university-action-label">Pay Tuition</span>
          </div>
          <div className="university-action-box">
            <div className="university-action-circle" style={{ backgroundColor: colors.primario }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 1v3M10 1v3M14 1v3" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <span className="university-action-label">Campus Dining</span>
          </div>
          <div className="university-action-box">
            <div className="university-action-circle" style={{ backgroundColor: colors.primario }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="university-action-label">Bookstore</span>
          </div>
          <div className="university-action-box">
            <div className="university-action-circle" style={{ backgroundColor: colors.primario }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="14" rx="2" stroke="white" strokeWidth="1.5"/>
                <path d="M4 10h16" stroke="white" strokeWidth="1.5"/>
                <circle cx="8" cy="15" r="1.5" fill="white"/>
                <circle cx="16" cy="15" r="1.5" fill="white"/>
                <path d="M7 4V2M17 4V2" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <span className="university-action-label">Transport Pass</span>
          </div>
        </div>

        {/* Student Life Section */}
        <div className="university-student-life">
          <h2 className="university-student-life-title">Your Student Life, Simplified</h2>
          <div className="university-tabs">
            <button
              className={`university-tab ${activeTab === 'monthly' ? 'active' : ''}`}
              style={activeTab === 'monthly' ? { borderBottomColor: colors.primario, color: colors.primario } : {}}
              onClick={() => setActiveTab('monthly')}
            >
              Monthly campus
            </button>
            <button
              className={`university-tab ${activeTab === 'tuition' ? 'active' : ''}`}
              style={activeTab === 'tuition' ? { borderBottomColor: colors.primario, color: colors.primario } : {}}
              onClick={() => setActiveTab('tuition')}
            >
              Upcoming tuition payment
            </button>
          </div>
          <div className="university-tab-content">
            {activeTab === 'monthly' ? (
              <div className="university-tab-placeholder">
                <p className="university-tab-info">Your monthly campus spending summary will appear here.</p>
              </div>
            ) : (
              <div className="university-tab-placeholder">
                <p className="university-tab-info">Your upcoming tuition payment details will appear here.</p>
              </div>
            )}
          </div>
        </div>

        {/* Bottom Navigation */}
        <div className="university-bottom-nav">
          <div className="university-nav-item active">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" stroke={colors.primario} strokeWidth="2"/>
            </svg>
            <span style={{ color: colors.primario }}>Home</span>
          </div>
          <div className="university-nav-item">
            <svg width="24" height="24" viewBox="0 0 59.1 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M58.7,83.4c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c-2.7-2.8-4.8-6.1-6.4-9.8c-0.2-0.6-0.8-1-1.4-1h-1.3h-5.8H20.6l36.6-46.9c0.2-0.3,0.3-0.6,0.3-1v-9.1c0-0.9-0.7-1.6-1.6-1.6H38.8h-0.7h-2V0.8c0-0.4-0.4-0.8-0.8-0.8H35h-0.3H23.9h-0.4h-0.3c-0.4,0-0.8,0.4-0.8,0.8v13.1h-2.8H19H3.1c-0.9,0-1.6,0.7-1.6,1.6V26c0,0.9,0.7,1.6,1.6,1.6h33.6L0.3,74C0.1,74.3,0,74.7,0,75v9.5c0,0.9,0.7,1.6,1.6,1.6h20.9v13.1c0,0.4,0.4,0.8,0.8,0.8h0.3H24h10.8H35h0.4c0.4,0,0.8-0.4,0.8-0.8V86.1H45h11.3h1.3c0.6,0,1.2-0.4,1.4-1C59.3,84.6,59.1,83.9,58.7,83.4" fill="#9CA3AF"/>
            </svg>
            <span>Zelle</span>
          </div>
          <div className="university-nav-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2"/>
              <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" stroke="#9CA3AF" strokeWidth="2"/>
            </svg>
            <span>Global Transfer</span>
          </div>
          <div className="university-nav-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 1l4 4-4 4" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 11V9a4 4 0 014-4h14" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7 23l-4-4 4-4" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 13v2a4 4 0 01-4 4H3" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Wire</span>
          </div>
          <div className="university-nav-item" onClick={handleSignOut} style={{ cursor: 'pointer' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Log out</span>
          </div>
        </div>
      </div>
    </div>
  );
};
